import { Input as AInput, Dropdown, Tooltip } from 'antd';
import TrackingInput from 'components/TrackingComponents/TrackingInput';
import React from 'react';
import { Link, LinkProps, NavLink } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import styled from 'styled-components';
import media from 'utils/mediaStyle';
import { CategoryContainer } from '../../components/CategoryNav/desktopNewDesign';
import defaultLogo from '../Image/noIMG.svg';
import SVGIcon from '../SVGIcon/SVGIcon';
import { commonDimensions } from 'utils/constants';
import { ArrowDownSwitchStoreIcon } from './ArrowDownSwitchStore';
import generateThumbnailImage from 'utils/generateThumbnailImage';

// sc6: styled(ReactSVG) làm type nổ (union ~500 prop). Cast về FC nhận src/alt để thu gọn.
export const KamereoLogo = styled(ReactSVG)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 165px;
  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    @media (max-width: 991px) {
      justify-content: flex-start;
    }
  }
  @media (max-width: 490px) {
    margin: 13.5px 0;
    width: fit-content;
    & > div {
      height: 23px;
    }
  }
` as unknown as React.FC<{ src: string; alt?: string; className?: string }>;

export const AntdInput = styled(AInput)`
  & .ant-input-search-icon {
    font-size: 18px;
    opacity: 0;
  }
  & .search-icon {
    position: absolute;
  }
`;

export const VerticalLine = styled.span`
  width: 1px;
  height: 50%;
  background: #808089;
  opacity: 0.25;
  margin: 0 10px;
`;

export const NavToggleIcon = styled(SVGIcon)`
  width: 53px;
  height: 100%;
  position: absolute;
  top: 0;
  cursor: pointer;
  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const LinkText = styled(Link)`
  color: inherit;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const TopNavBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -8px;
  width: 16px;
  height: 16px;
  background: #ff4852;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  @media (max-width: 576px) {
    top: 0;
    right: -3px;
  }
`;

export const RedDotBadge = styled.div`
  position: absolute;
  top: 16px;
  right: 10px;
  width: 14px;
  height: 14px;
  background: #ff4852;
  border-radius: 50%;
  border: 1px solid #ffffff;
  z-index: 10;
  @media (max-width: 767px) {
    top: 8px;
    right: 4px;
  }
`;

export const TopNavItem = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-width: 46pt;
  position: relative;
  ${media.sm`
    padding: 10pt;
    min-width: 50pt;
  `};
`;

interface TopNavLinkItemProps {
  isLogoNav?: boolean;
}

export const TopNavLinkItem = styled(({ isLogoNav, ...props }: LinkProps & { isLogoNav: boolean }) => (
  <Link {...props} />
))<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ isLogoNav }: TopNavLinkItemProps) => (isLogoNav === true ? '10pt 0px' : '10pt')};
  padding-left: 0px;
  cursor: pointer;
  position: relative;
  height: 100%;
  color: #292d32;

  :hover {
    color: #43a047;
  }

  @media (max-width: 490px) {
    padding: ${({ isLogoNav }: TopNavLinkItemProps) => (isLogoNav === true ? '0' : '0pt 6pt')};
  }
  ${SVGIcon} {
    @media (max-width: 767px) {
      filter: none;
    }
  }
  &.no-padding {
    padding: 0;
  }
`;

export const TopNavButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  height: 100%;
  &:hover {
    color: #43a047;
  }
  @media (max-width: 767px) {
    color: #ffffff;
    padding: 12pt 8pt;
    &:hover {
      color: #ffffff;
    }
  }
  button {
    font-size: 16px !important;
  }
`;

export const TopNavButtonHiddenOnMobile = styled(TopNavButton)`
  display: flex;
  height: 100%;
  font-weight: 500;
  color: #111827;
  // @media (max-width: 1076px) {
  //   display: none;
  // }
  & > .ant-btn {
    font-weight: 500;
    background: #43a047;
    padding: 5px 12px;
    height: auto;
    border: none;
    border-radius: 8px !important;
    line-height: 25.6px;
    box-shadow: none;
    &:hover {
      background: #6fc373 !important;
    }
  }
  ${({ hasBorder }) =>
    hasBorder &&
    `
      border: 1px solid #d5d7d5;
      border-radius: 8px;
      span {
        font-size: 16px;
        color: #2F382C;
        font-weight: 500;
      }
        &:hover {
          border-color: #43A047;
          span {
            color: #43A047;
          }
        }
    `}
  ${({ isBtnText }) =>
    isBtnText &&
    `
    padding: 5px 12px;
    background: transparent;
  `}
`;

export const ProfileInfo = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const TopNavMenuItem = styled(Dropdown)<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%;
  @media (min-width: 1024px) {
    margin-left: ${({ mgLeft }) => (mgLeft ? '16px' : '0px')};
  }
  svg {
    width: 10px !important;
    height: 5px !important;
    color: #4b5563 !important;
  }
`;

export const Avatar = styled.img`
  width: 28pt;
  height: 28pt;
  border-radius: 4px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  ${({ homePage }) =>
    homePage &&
    `
    width: 100%;
  `}
  @media (min-width: 1025px) {
    width: 100%;
  }
  ${media.xl`
    width: 100%;
    max-width: 800px;
  `};
  & > .ant-input-affix-wrapper {
    border-radius: 80px !important;
    padding: 4px 16px !important;
    // @media (max-width: 767px) {
    //   border: none !important;
    // }
  }
  @media (max-width: 991px) {
    & > .ant-input-affix-wrapper {
      height: 36px !important;
      input {
        height: 25px !important;
        &::placeholder {
          font-size: 14px;
        }
      }
    }
  }
  /* Mobile: the field is only a trigger for the full-screen search overlay.
     Taps are handled by the sibling tap-catcher instead, because iOS Safari
     zooms the viewport whenever an input below 16px takes focus and the hero
     search pill renders its input at 12px. */
  ${({ $triggerOnly }) =>
    $triggerOnly &&
    `
    & > .ant-input-affix-wrapper {
      pointer-events: none;
    }
  `}
`;

export const alternativeImage = (name) => `https://ui-avatars.com/api/?name=${name}&size=512`;

export const ProfileInfoContainer = ({
  user,
  ...props
}: {
  user: { name: string; title: string; imageUrl: string; email: string };
}) => (
  <ProfileInfo {...props}>
    <Avatar src={generateThumbnailImage(user.imageUrl, 64) || alternativeImage(user.name) || defaultLogo} />
    <ArrowDownSwitchStoreIcon color={'#596056'} />
  </ProfileInfo>
);

export const MenuLabel = styled.div`
  flex: 1;
  font-size: 14px;
`;

export const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
  width: 100%;
  ${MenuLabel} {
    color: ${({ color }) => color};
  }
  ${SVGIcon} {
    path {
      fill: ${({ color }) => color};
    }
  }
  ${SVGIcon} + ${MenuLabel} {
    margin-left: 10pt;
  }
`;

export const MenuItemLink = styled(Link)`
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87);
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  flex-wrap: nowrap;
  padding: 8pt;
  margin: 0 !important;
  width: 100%;
  ${MenuLabel} {
    color: ${({ color }) => color};
  }
  ${SVGIcon} {
    path {
      fill: ${({ color }) => color};
    }
  }
  ${SVGIcon} + ${MenuLabel} {
    margin-left: 10pt;
  }
`;

export const TopNavWrapper = styled.header<{ translateYValue?: number; $mobileBgColor?: string }>`
  color: rgba(0, 0, 0, 0.87);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background: #f9fafc;
  transition: transform 0.3s ease-in-out;
  will-change: transform;
  ${media.md`
    // box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
    // filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.10));
    box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.08), 0 1px 0 0 rgba(0, 0, 0, 0.05);
    gap: 10px;
    background: #fcfffc;
    flex-wrap: nowrap;
    transform: translateY(-107px);
    transform: translateY(${({ translateYValue }) => translateYValue}px);
  `};
  @media (max-width: 991px) {
    box-shadow: unset;
    filter: none;
    background: ${({ $mobileBgColor }) => $mobileBgColor || '#f9fafc'};
  }
`;

export const LeftNav = styled.nav`
  display: flex;
  align-items: center;
  ${media.md`
    order: 0;
  `};
  @media (max-width: 991px) {
    gap: 12px;
    margin-left: 16px;
  }
`;

export const MiddleNav = styled.nav`
  display: flex;
  align-items: center;
  order: 3;
  width: 100%;
  padding: 0px 16px;
  justify-content: space-between;
  gap: 10px;
  ${media.md`
    order: 2;
    width: auto;
    padding: unset;
    flex: 1;
`};
  @media (max-width: 991px) {
    justify-content: flex-end;
  }
`;

export const RightNav = styled.nav`
  display: flex;
  margin-left: auto;
  align-items: center;
  order: 2;
  gap: 12px;
  position: relative;
  ${media.md`
    order: 3;
  `};
  &.login {
    gap: 24px;
  }
  @media (max-width: 767px) {
    gap: unset !important;
    padding: 0 16px 0 0;
  }
  @media (min-width: 992px) {
    &.login {
      padding-left: 3px;
    }
  }
  transition: all 0.8 ease;
  transform: translateY(0px);
  ${({ transition }) =>
    transition &&
    `
    transform: translateY(67px);
  `}
`;

export const EnvIndicator = styled.div`
  line-height: 33pt;
  text-transform: uppercase;
  font-size: 15pt;
  color: white;
  background: rgb(254, 80, 67);
  height: 100%;
  padding: 2pt 10pt;
  display: none;
  position: absolute;
  top: 0px;
  left: -55px;
  ${media.md`
    display: flex;
    align-items: center;
  `};
`;

export const TopNavTopContent = styled.div`
  display: none;
  padding: 0 40px;
  color: #2f382c;
  font-size: 14px;
  font-weight: 500;
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  margin: 0 auto;
  ${media.md`
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `};
`;

export const TopNavTopContentWrapper = styled.div`
  display: none;
  background: #f7f7f8;
  height: 38px;
  border-bottom: 1px solid #eaecf0;
  position: relative;
  ${media.md`
    display: block;
  `};
`;

export const TopNavTopContentLeft = styled.div`
  display: flex;
  align-items: center;
`;
export const TopNavTopContentRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  min-height: 28px;
  .top-nav-item {
    position: relative;
  }
`;

export const StyledLink = styled(NavLink)<any>`
  display: flex;
  gap: 9pt;
  align-items: center;
  position: relative;
  span {
    color: #424242;
  }
  &.active,
  &:hover {
    span {
      color: #43a047;
    }
    div div svg {
      filter: invert(53%) sepia(9%) saturate(3454%) hue-rotate(73deg) brightness(99%) contrast(68%);
    }
  }
  &:first-child:hover ~ ${CategoryContainer} {
    display: block;
  }
  @media (max-width: 1024px) {
    position: relative;
    flex-direction: column;
    gap: 3px;
    margin: 0 auto;
    width: fit-content;
    & > span {
      text-align: center;
      font-size: 12px;
    }
    &:hover {
      span {
        color: #424242;
      }
      div div svg {
        filter: unset;
      }
    }
    &.active {
      &:before {
        content: '';
        background: #43a047;
        width: 55px;
        height: 2px;
        position: absolute;
        top: -15px;
        left: 50%;
        transform: translateX(-50%);
        ${({ cart }) =>
          cart &&
          `
          top: -13px;
        `}
      }
      span {
        color: #43a047;
      }
    }
    ${({ cart }) =>
      cart &&
      `
      gap: 0px;
      `}
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
  padding: 0 8px;
  &:not(:last-child):before {
    content: '';
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
    width: 1px;
    height: 12px;
    background: rgba(255, 255, 255, 0.5);
  }
`;

export const TopNavTooltip = styled(Tooltip)``;

export const TopNavContent = styled.div`
  display: flex;
  // flex-wrap: wrap;
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  margin: 0 auto;
  background: #ffffff;
  position: relative;
  z-index: 2;
  height: 64px;
  ${media.md`
    gap: 24px;
    flex-wrap: nowrap;
    padding: 0 16px;
    align-items: center;
  `};
  ${media.lg`
    padding: 0 40px;
  `}
  @media (max-width: 991px) {
    background: ${({ bgColor }) => (bgColor ? bgColor : '#ffffff')};
    height: 50px;
  }
  ${CategoryContainer} {
    top: 99.5px;
    margin-left: 13px;
    border-top: 1px solid rgba(158, 158, 158, 0.2);
  }
`;

export const CustomSearchInput = styled(TrackingInput)`
  .ant-input {
    background: none;
    border-radius: 8px;
    height: 30px;
    border: 1px solid #bdbdbd;
    max-width: 800px;
    @media (max-width: 767px) {
      background: #ffffff;
      font-size: 16px !important;
    }
  }
  .ant-input-prefix {
    margin-right: 8px;
  }
  flex: 1;
`;
export const SwitchStoreContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  @media (max-width: 767px) {
    // padding: 0 24px 0 10px;
    & svg {
      width: 14px;
    }
  }
  @media (max-width: 991px) {
    span {
      color: ${({ textColor }) => textColor || '#111827'};
    }
  }
`;

export const SwitchRegionContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  ${media.md`
    background: rgba(255, 255, 255, 0.15);
    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  `}
`;

export const SwitchStoreMobileContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #ffffff;
    gap: 4px;
    p {
      font-size: 16px;
    }
    &:last-child {
      p {
        font-size: 14px;
      }
    }
  }
  & svg {
    width: 20px;
  }
`;

export const SwitchStoreTextBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwitchStoreText = styled.p`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const SwitchStoreStaticText = styled.p`
  color: #596056;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const StoreName = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 120px;
  font-weight: 500;
  color: #2f382c;
  @media (max-width: 767px) {
    max-width: 130px;
    color: #2f382c;
  }

  @media (max-width: 425px) {
    max-width: 80px;
  }

  @media (max-width: 375px) {
    max-width: 60px;
  }

  @media (max-width: 320px) {
    max-width: 20px;
  }
`;

export const SignUpButton = styled.div`
  padding: 6px 12px;
  background: #ffffff;
  border-radius: 8px !important;
  color: #4caf50;
  font-size: 12px;
  font-weight: 500;
`;
export const SignInSignUpWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  @media (max-width: 991px) {
    display: none;
  }
`;

export const Header = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER - 40}px;
  margin: 0 auto;
  height: 100%;
  padding: 0 16px;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  ${media.lg`
    gap: 56px;
    `}
`;

export const HeaderWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  background: rgb(252, 255, 252);
  width: 100%;
  height: 40px;
  transition: all 0.2s ease-in-out;
  ${media.lg`
    // padding-bottom: 12px;
    height: 64px;
    `}
  ${({ isVisible, showTopHeader, isDesktop }) => `
    opacity: ${isVisible ? 1 : 0};
    pointer-events: ${isVisible ? 'initial' : 'none'};
    ${isDesktop && showTopHeader ? 'height: 40px !important' : ''};
  `}
`;

export const ScrollProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: #3c9041;
  width: ${({ width }) => width}%;
  transition: width 0.2s ease-out;
`;

export const HeaderText = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: #242527;
  cursor: pointer;
  flex-shrink: 0;
  ${({ active }) =>
    active &&
    `
  color: #3C9041;
`}
  ${media.md`
  font-size: 16px;
  line-height: 24px;
  `}
`;

export const SectionBar = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  margin: 0 auto;
  background: #15803d;
`;

export const SectionItemList = styled.div`
  display: flex;
  gap: 24px;
`;

export const SectionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  ${({ isSeparate }) =>
    isSeparate &&
    `
  &:not(:last-child):after {
    content: '';
    width: 1px;
    height: 20px;
    background: #eaebea;
    margin-left: 16px;
  }
  `}
  ${({ active }) =>
    active &&
    `
    & span {
      color: #43A047;
    }
  `}
  ${({ noCursor }) =>
    noCursor &&
    `
    cursor: auto;
  `}
`;

export const SectionItemText = styled.span`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '12')}px;
  font-weight: 500;
  color: #2f382c;
  flex-shrink: 0;
`;
